import { Controller, useFormContext } from "react-hook-form";
import type { CommunityMemberSelectProps } from "@circle-react-uikit/CommunityMemberSelect";
import { CommunityMemberSelect } from "@circle-react-uikit/CommunityMemberSelect";

export interface FormCommunityMemberSelectProps
  extends CommunityMemberSelectProps {
  name: string;
}

export const FormCommunityMemberSelect = ({
  name,
  ...passThroughProps
}: FormCommunityMemberSelectProps) => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      render={({
        field: { onChange, value, name },
      }: {
        field: {
          onChange: (value: any) => void;
          value: any;
          name: string;
        };
      }) => (
        <CommunityMemberSelect
          {...passThroughProps}
          name={name}
          onChange={item => onChange(item.value)}
          value={value}
        />
      )}
    />
  );
};

FormCommunityMemberSelect.displayName = "Form.CommunityMemberSelect";
